module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_photo-fe1d675987a0078ad79d2601e7167f5a.jpg";